import { createReducer } from '@reduxjs/toolkit'

import { BoostFarmState } from '../types'
import { updateSelectedMoleIds } from './actions'

const boostFarm = createReducer<BoostFarmState>(
  {
    selectedMoleIds: [],
  },
  (builder) =>
    builder.addCase(updateSelectedMoleIds, (state, { payload: { molesIds } }) => {
      return {
        ...state,
        selectedMoleIds: molesIds,
      }
    }),
)

export default boostFarm
